module.exports = __webpack_public_path__ + "img/icon-balance.981a140b.svg";